var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinocular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "56px",
    viewBox: "0 0 112 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-2---6-Error-MOBILE-",
    transform: "translate(-104.000000, -236.000000)",
    fill: "#68BE6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Binoculars_1616633",
    transform: "translate(104.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.12,17.78 C14.84,18.34 8.96,24.22 8.4,31.5 C8.4,32.06 8.82,32.48 9.38,32.48 L9.38,32.48 C9.8,32.48 10.22,32.06 10.36,31.64 C10.92,25.2 15.96,20.16 22.4,19.6 C22.82,19.6 23.24,19.18 23.24,18.62 L23.24,18.62 C23.24,18.2 22.68,17.78 22.12,17.78 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.38,9.38 C10.5,9.38 0,19.88 0,32.76 C0,45.64 10.5,56 23.38,56 C36.26,56 46.76,45.5 46.76,32.62 C46.76,19.74 36.26,9.38 23.38,9.38 Z M23.38,50.4 C13.58,50.4 5.6,42.42 5.6,32.62 C5.6,22.82 13.58,14.84 23.38,14.84 C33.18,14.84 41.16,22.82 41.16,32.62 C41.16,42.42 33.18,50.4 23.38,50.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,17.78 C80.22,18.34 74.34,24.22 73.78,31.5 C73.78,32.06 74.2,32.48 74.76,32.48 L74.76,32.48 C75.18,32.48 75.6,32.06 75.74,31.64 C76.3,25.2 81.34,20.16 87.78,19.6 C88.2,19.6 88.62,19.18 88.62,18.62 L88.62,18.62 C88.48,18.2 88.06,17.78 87.5,17.78 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.62,9.38 C75.74,9.38 65.24,19.88 65.24,32.76 C65.24,45.64 75.74,56 88.62,56 C101.5,56 112,45.64 112,32.62 C112,19.6 101.5,9.38 88.62,9.38 Z M88.62,50.4 C78.82,50.4 70.84,42.42 70.84,32.62 C70.84,22.82 78.82,14.84 88.62,14.84 C98.42,14.84 106.4,22.82 106.4,32.62 C106.4,42.42 98.42,50.4 88.62,50.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.62,7.42 C90.86,7.42 92.96,7.7 94.92,8.26 C91.14,5.46 86.52,3.78 81.62,3.78 C78.12,3.64 74.76,4.48 71.82,5.74 C69.3,2.24 65.1,-9.9475983e-15 60.48,-9.9475983e-15 L51.38,-9.9475983e-15 C46.76,-9.9475983e-15 42.56,2.24 40.04,5.74 C37.1,4.48 33.74,3.78 30.24,3.78 C25.34,3.92 20.72,5.6 16.94,8.26 C18.9,7.7 21.14,7.42 23.24,7.42 C37.1,7.42 48.44,18.76 48.44,32.62 C48.44,37.38 47.18,41.72 44.94,45.5 C50.4,41.3 53.9,34.72 54.04,27.44 C54.04,25.2 53.76,23.1 53.2,21 C52.78,19.32 54.04,17.64 55.86,17.64 L56,17.64 C57.82,17.64 59.08,19.32 58.66,21 C58.1,23.1 57.82,25.2 57.82,27.44 C57.96,34.72 61.46,41.3 66.92,45.5 C64.68,41.72 63.42,37.24 63.42,32.62 C63.42,18.76 74.76,7.42 88.62,7.42 Z M56,11.2 C53.9,11.2 52.22,9.52 52.22,7.42 C52.22,5.32 53.9,3.64 56,3.64 C58.1,3.64 59.78,5.32 59.78,7.42 C59.78,9.52 58.1,11.2 56,11.2 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocular);
export default __webpack_public_path__ + "static/media/binocular.9dd385ec2feb0fe40919edb0ca91c692.svg";
export { ForwardRef as ReactComponent };